<template>
  <section id="homeThankYouSreen">
    <div class="container">
      <div class="logo">
        <img src="/img/shaves_logo.svg" alt>
      </div>
      <div class="textCopy">
        <h4>We're all done - thanks for signing up</h4>
        <h2>Have a great day!</h2>
        <p>This registration will close & clear all information in {{secondsRemaining}} seconds</p>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "individualthankyou",
  data() {
    return {
      secondsRemaining: 6
    };
  },
  methods: {},
  mounted() {
    setInterval(() => {
      this.secondsRemaining -= 1;
      if (this.secondsRemaining == 0) {
        this.$router.push("/");
      }
    }, 1000);
  }
};
</script>